/**
 * Coupon input — Task 35.2
 */
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useCart, useApplyCoupon, useRemoveCoupon } from '@/hooks/useCart'
import { useFeatures } from '@/hooks/useFeatures'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { X } from 'lucide-react'

export function CouponInput() {
  const { t } = useTranslation('cart')
  const { features } = useFeatures()
  const { data: cart } = useCart()
  const applyCoupon = useApplyCoupon()
  const removeCoupon = useRemoveCoupon()
  const [code, setCode] = useState('')

  if (!features.enable_coupons) {
    return null
  }

  if (cart?.coupon_code) {
    return (
      <div className="flex items-center justify-between rounded-md bg-green-50 px-3 py-2 text-sm">
        <span className="text-green-700">
          {t('coupon_applied')} <strong>{cart.coupon_code}</strong>
        </span>
        <button
          onClick={() => removeCoupon.mutate()}
          className="ml-2 text-green-600 hover:text-green-800"
          aria-label="Remove coupon"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    )
  }

  return (
    <div className="flex gap-2">
      <Input
        placeholder={t('coupon_code')}
        value={code}
        onChange={(e) => setCode(e.target.value)}
        className="flex-1"
      />
      <Button
        variant="outline"
        onClick={() => code.trim() && applyCoupon.mutate(code.trim())}
        loading={applyCoupon.isPending}
        disabled={!code.trim()}
      >
        {t('apply')}
      </Button>
    </div>
  )
}
